<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">
            <h1 class="text-center">📱 Installer BrickFirst</h1>
          </div>
          <div class="card-body">
            
            <!-- App déjà installée -->
            <div v-if="isInstalled" class="alert alert-success text-center">
              <h4>✅ Application déjà installée !</h4>
              <p>L'application est accessible depuis votre écran d'accueil.</p>
            </div>

            <!-- Bouton pour Android/Desktop -->
            <div v-else-if="showInstallButton && !isIOS" class="text-center">
              <p class="lead">Installez BrickFirst comme une application sur votre appareil</p>
              <button @click="handleInstall" class="btn btn-primary btn-lg">
                <span v-if="installing" class="spinner-border spinner-border-sm me-2"></span>
                📱 Installer l'application
              </button>
            </div>

            <!-- Instructions pour iOS -->
            <div v-else-if="isIOS && !isInstalled" class="ios-section">
              <div class="alert alert-info">
                <h5>📱 Installation sur iPhone/iPad</h5>
                <p>Pour installer l'application :</p>
                <ol class="text-start">
                  <li>Appuyez sur le bouton <strong>Partager</strong> <span class="badge bg-primary">⬆️</span> (en bas de Safari)</li>
                  <li>Faites défiler vers le bas</li>
                  <li>Sélectionnez <strong>"Sur l'écran d'accueil"</strong></li>
                  <li>Appuyez sur <strong>"Ajouter"</strong></li>
                </ol>
              </div>
            </div>

            <!-- Message par défaut -->
            <div v-else class="alert alert-warning text-center">
              <p class="mb-0">Ouvrez ce site dans Chrome, Edge ou Safari pour installer l'application.</p>
            </div>

            <!-- Avantages -->
            <div class="mt-4">
              <h5>Pourquoi installer l'application ?</h5>
              <ul class="list-unstyled">
                <li>🚀 <strong>Accès rapide</strong> depuis votre écran d'accueil</li>
                <li>📴 <strong>Fonctionne hors ligne</strong></li>
                <li>🔔 <strong>Notifications</strong> en temps réel</li>
                <li>💾 <strong>Légère</strong> - prend moins de place qu'une app native</li>
                <li>⚡ <strong>Rapide</strong> - chargement instantané</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PWAInstall',
  data() {
    return {
      showInstallButton: false,
      deferredPrompt: null,
      isIOS: false,
      isInstalled: false,
      installing: false
    };
  },
  mounted() {
    // Détecter iOS
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    // Vérifier si déjà installé
    this.isInstalled = window.matchMedia('(display-mode: standalone)').matches || 
                       window.navigator.standalone === true;

    // Écouter l'événement d'installation (Android/Desktop)
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showInstallButton = true;
    });

    // Quand l'app est installée
    window.addEventListener('appinstalled', () => {
      this.showInstallButton = false;
      this.isInstalled = true;
      alert('✅ BrickFirst installé avec succès ! 🎉');
    });
  },
  methods: {
    async handleInstall() {
      if (!this.deferredPrompt) return;
      
      this.installing = true;
      
      // Afficher le prompt d'installation
      this.deferredPrompt.prompt();
      
      // Attendre la réponse
      const { outcome } = await this.deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        console.log('✅ Installation acceptée');
      } else {
        console.log('❌ Installation refusée');
      }
      
      this.deferredPrompt = null;
      this.showInstallButton = false;
      this.installing = false;
    }
  }
};
</script>

<style scoped>
.ios-section ol {
  font-size: 1.1rem;
}

.ios-section li {
  margin: 1rem 0;
}

.badge {
  font-size: 1.2rem;
}

ul li {
  padding: 0.5rem 0;
}
</style>